import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useWorkOrderTemplatesTabViewModel = ({
  orderTemplateId,
  refresh,
}) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedWorkOrderTemplate, setSelectedWorkOrderTemplate] = useState(
    {}
  );
  const [allWorkOrderTemplates, setAllWorkOrderTemplates] = useState([]);

  const stateManager = useComponentState();

  const openDeleteModal = (workOrderTemplate) => {
    setIsDeleteModalOpen(true);
    setSelectedWorkOrderTemplate(workOrderTemplate);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const closeEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedWorkOrderTemplate({});
  };

  const deleteWorkOrderTemplate = () => {
    stateManager.run(async () => {
      const { id, name, modifiedOn } = selectedWorkOrderTemplate;

      const { status } = await taskService.workOrderDependencyMaps.delete({
        id,
        modifiedOn,
        toastMessageConfig: {
          success: {
            text: `${name} was deleted.`,
          },
        },
      });

      if (status === HTTP_STATUSES.OK) {
        refresh();
      }

      closeDeleteModal();
    });
  };

  const handleUpdateOrderTemplateWorkOrderTemplate = (data) => {
    stateManager.run(async () => {
      const { status } = await taskService.workOrderDependencyMaps.create({
        orderTemplateId,
        workOrderTemplateId: data.id,
        data,
        toastMessageConfig: {
          success: {
            text: `${data.name} was updated successfully.`,
          },
        },
      });

      if (status === HTTP_STATUSES.OK) {
        closeEditModal();
        refresh();
      }
    });
  };

  const loadWorkOrderTemplates = () => {
    stateManager.run(async () => {
      const response = await taskService.workOrderTemplates.getAll({
        sort: "name asc",
      });

      if (response.status === HTTP_STATUSES.OK) {
        setAllWorkOrderTemplates(
          response.data.map((wot) => ({
            ...wot,
            value: wot.name,
            label: wot.name,
          }))
        );
      }
    });
  };

  return {
    selectedWorkOrderTemplate,
    isDeleteModalOpen,
    deleteWorkOrderTemplate,
    openDeleteModal,
    closeDeleteModal,
    closeEditModal,
    isEditModalVisible,
    handleUpdateOrderTemplateWorkOrderTemplate,
    loadWorkOrderTemplates,
    allWorkOrderTemplates,
  };
};
